//? PLUGINS //
import axios, { AxiosRequestConfig } from 'axios';

//? EXTRAS //
import { API_URL } from 'utilities/constants';

const axiosClient = () => {
	const defaultOptions = {
		baseURL: API_URL,
		method: 'get',
		headers: {
			'Content-Type': 'application/json',
		},
		withCredentials: true,
	};

	//* Create instance
	let instance = axios.create(defaultOptions);

	//* Set the AUTH token for any request
	instance.interceptors.request.use((config: AxiosRequestConfig) => {
		if (config.headers === undefined) return config;

		const token = localStorage.getItem('token');
        const tenantId = sessionStorage.getItem('__tenantId');
        if (tenantId) {
            const params = new URLSearchParams(config.params);
            params.append('__tenant', tenantId);
            config.params = params;
        }
		config.headers.Authorization = token ? `Bearer ${token}` : '';
		return config;
	});

	instance.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        //catches if the session ended!
        if ( error.response.status === 403) {
            window.location.href = `${process.env.REACT_APP_BASE_HREF}/unauthorized`;
        }
        return Promise.reject(error);
    });

    // TODO: reenable this if the backend solution doesnt work
    // instance.interceptors.response.use((config: AxiosRequestConfig) => {
    //     if (config.headers === undefined) return config;

    //     console.log('headers are present')
    //     if (config.headers.location === undefined) return config;
    //     alert('location header is present');
        
    //     window.location.href = config.headers.location as string;
    //     return config;
    // });

	return instance;
};

export default axiosClient();
